<template>
  <div
    class="home-page"
    :class="{
      en: $i18n.locale === 'en-US',
    }"
  >
    <!-- 线条装饰 -->
    <LineDecoration />
    <!-- banner -->
    <BannerList />
    <!-- 关于我们 -->
    <AboutUs />
    <!-- 核心技术 -->
    <CoreSection />
    <!-- 我们的产品 -->
    <OurProducts />
    <!-- 生态朋友圈 -->
    <div class="compoany">
      <cooperationPartner :speed="5" :direction="'left'" />
    </div>
    <div class="footerss">
      <FooterComponents />
    </div>
  </div>
</template>

<script>
import WOW from "wowjs";
import LineDecoration from "./components/LineDecoration.vue";
import BannerList from "./components/BannerList.vue";
import AboutUs from "./components/AboutUs.vue";
import CoreSection from "./components/CoreSection.vue";
import OurProducts from "./components/OurProducts.vue";
import FooterComponents from "@/components/FooterComponents.vue";
import cooperationPartner from "./components/cooperationPartner.vue";

export default {
  components: {
    LineDecoration,
    BannerList,
    AboutUs,
    CoreSection,
    OurProducts,
    cooperationPartner,
    FooterComponents,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    //特效
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
  },
  beforeDestroy() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.home-page {
  /*合作案例  */
  .compoany {
    width: 100%;
    height: 45rem;
  }

  .footerss {
    width: 100%;
    height: 18rem;
  }
}
</style>
